// Adaptive text color util for branding-driven UI.
// Given a hex background, returns '#1f2937' (slate-800) for light backgrounds
// or '#ffffff' for dark backgrounds, ensuring readable contrast.
export const getContrastText = (hex, lightText = '#ffffff', darkText = '#1f2937') => {
  if (!hex || typeof hex !== 'string') return lightText;
  const s = hex.replace('#', '').trim();
  if (s.length !== 3 && s.length !== 6) return lightText;
  const full = s.length === 3 ? s.split('').map((c) => c + c).join('') : s;
  const r = parseInt(full.substring(0, 2), 16);
  const g = parseInt(full.substring(2, 4), 16);
  const b = parseInt(full.substring(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return lightText;
  // Perceived luminance (Rec.601). 0=black, 1=white.
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.62 ? darkText : lightText;
};

export const isLightColor = (hex) => getContrastText(hex) === '#1f2937';
